import {
  UPDATE_PROJECT_REQUEST,
  UPDATE_PROJECT_ERROR,
  UPDATE_PROJECT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => async (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_PROJECT_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_PROJECT_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_PROJECT_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "project";
  context.entityLocation = RESOURCES.Projects;

  return context.execute(context)(entity, entityTableData)(state, action);
};